import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './SecuritySettingsScreen.scss';
import SecuritySettingsRow from './SecurityScreenRow';
import useMfaEnabled from '../../../../hooks/useIsMfaEnabledFlag';

const SecuritySettingsScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isMfaEnabled = useMfaEnabled();

  const onPressChangePassword = () => {
    navigate('password-update');
  };

  const onPress2FA = () => {
    navigate('mfa-authentication');
  };

  return (
    <div className='security-settings'>
      <div className='security-settings__container'>
        <div className='security-settings__items'>
          <SecuritySettingsRow
            name='change-password'
            onPress={onPressChangePassword}
            title={t('Change password')}
          />
          {isMfaEnabled && (
            <SecuritySettingsRow
              name='2fa'
              onPress={onPress2FA}
              title={t('2-Factor Authentication')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SecuritySettingsScreen;
